import {ToastType} from '@Components/toast/toast.types';

export const INVALID_TARGET_ERROR = 'Invalid target position';

export const showWarningToast = (message: string): void => {
  window.PMW.showToast({duration: 3000, title: message, type: ToastType.WARNING});
};

// Social Links utility functions
export const htmlToElements = (html: string): HTMLElement => {
  const template = document.createElement('template');
  template.innerHTML = html;
  return template.content.childNodes[0] as HTMLElement;
};

export const getSanitizedUrl = (url: string): string => {
  url = decodeURI(url);
  url = encodeURI(url);
  return url;
};

export const addHttpsToUrl = (url: string): string => {
  return `https://${url}`;
};

export const addMailToToEmail = (url: string): string => {
  return `mailto:${url}`;
};

export const getUrlHasHttps = (url: string): boolean => {
  return /^[a-zA-Z]+:\/\//.test(url);
};

export const getEmailHasMailTo = (url: string): boolean => {
  return url.startsWith('mailto:');
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

const MIN_PHONE_DIGITS = 5;

export const isValidPhoneNumber = (value: string): boolean => {
  if (!/^\+?[\d\s\-().]+$/.test(value)) {
    return false;
  }
  const digitCount = value.replace(/\D/g, '').length;
  return digitCount >= MIN_PHONE_DIGITS;
};

export const getPhoneHasTel = (url: string): boolean => {
  return url.startsWith('tel:');
};

export const addTelToPhoneNumber = (url: string): string => {
  return `tel:${url}`;
};

export const updateInputValueForSocialLinkInputElement = (inputEl: JQuery, url: string): void => {
  if (!inputEl) {
    return;
  }
  inputEl.val(url);
};
